import { faAngleLeft, faAngleRight, faArrowAltCircleDown, faArrowCircleRight, faBarcode, faBars, faBellSlash, faBirthdayCake, faBox, faCalendarCheck, faCalendar, faCalendarDay, faCarSide, faCheck, faCheckCircle, faChevronCircleRight, faChevronDown, faChevronLeft, faChevronRight, faChevronUp, faClinicMedical, faClock, faCloud, faCloudUploadAlt, faCog, faCopy, faDesktop, faDoorOpen, faDraftingCompass, faEllipsisV, faEnvelope, faExclamationCircle, faExpandAlt, faExpandArrowsAlt, faExternalLinkAlt, faEye, faEyeSlash, faFile, faFilePdf, faFlag, faFlask, faGlobeAmericas, faGripHorizontal, faHome, faIdBadge, faInfoCircle, faLemon, faLock, faMap, faMapMarker, faMapMarkerAlt, faMinus, faNotEqual, faPaperPlane, faPaperclip, faPen, faPhone, faPlay, faPlusCircle, faQuestionCircle, faQuestion, faRoute, faSignInAlt, faSignOutAlt, faStore, faStream, faSync, faSyncAlt, faThumbtack, faTimes, faTimesCircle, faToggleOff, faTrash, faTrashAlt, faUndo, faUnlock, faUser, faUserAlt, faUserCheck, faUserClock, faUserMd, faUserPlus, faWalking, faWallet } from '@fortawesome/sharp-regular-svg-icons';
import { faArrowLeft, faArrowRight, faChevronCircleRight as faChevronCircleRight$1, faMagnifyingGlass, faPlus } from '@fortawesome/sharp-solid-svg-icons';

// A given icon should only be included in one icon pack. the `Icon` component
// will automatically choose the correct pack based on the setup here.
// Ensure that the import source matches the array name. It will only be matched
// correctly in the Icon component if the default icon name is used (some are
// aliased). Check the iconLeft dropdown in the ButtonComponent story to
// validate the default icon name.
const faSharpRegularIcons = [
    faAngleLeft,
    faAngleRight,
    faArrowAltCircleDown,
    faArrowCircleRight,
    faBarcode,
    faBars,
    faBellSlash,
    faBirthdayCake,
    faBox,
    faCalendarCheck,
    faCalendar,
    faCalendarDay,
    faCarSide,
    faCheck,
    faCheckCircle,
    faChevronCircleRight,
    faChevronDown,
    faChevronLeft,
    faChevronRight,
    faChevronUp,
    faClinicMedical,
    faClock,
    faCloud,
    faCloudUploadAlt,
    faCog,
    faCopy,
    faDesktop,
    faDoorOpen,
    faDraftingCompass,
    faEllipsisV,
    faEnvelope,
    faExclamationCircle,
    faExpandAlt,
    faExpandArrowsAlt,
    faExternalLinkAlt,
    faEye,
    faEyeSlash,
    faFile,
    faFilePdf,
    faFlag,
    faFlask,
    faGlobeAmericas,
    faGripHorizontal,
    faHome,
    faIdBadge,
    faInfoCircle,
    faLemon,
    faLock,
    faMap,
    faMapMarker,
    faMapMarkerAlt,
    faMinus,
    faNotEqual,
    faPaperPlane,
    faPaperclip,
    faPen,
    faPhone,
    faPlay,
    faPlusCircle,
    faQuestionCircle,
    faQuestion,
    faRoute,
    faSignInAlt,
    faSignOutAlt,
    faStore,
    faStream,
    faSync,
    faSyncAlt,
    faThumbtack,
    faTimes,
    faTimesCircle,
    faToggleOff,
    faTrash,
    faTrashAlt,
    faUndo,
    faUnlock,
    faUser,
    faUserAlt,
    faUserCheck,
    faUserClock,
    faUserMd,
    faUserPlus,
    faWalking,
    faWallet,
];
const faSharpRegularIconNames = faSharpRegularIcons.map((icon) => icon.iconName);
const faSharpRegularIconPackByName = faSharpRegularIconNames
    .reduce((packByName, name) => ({
    ...packByName,
    [name]: 'fasr',
}), {});
const faSharpSolidIcons = [
    faArrowLeft,
    faArrowRight,
    faChevronCircleRight$1,
    faMagnifyingGlass,
    faPlus,
];
const faSharpSolidIconNames = faSharpSolidIcons.map((icon) => icon.iconName);
const faSharpSolidIconPackByName = faSharpSolidIconNames
    .reduce((packByName, name) => ({
    ...packByName,
    [name]: 'fass',
}), {});
const faIcons = [
    ...faSharpRegularIcons,
    ...faSharpSolidIcons,
];
const faIconPackByName = {
    ...faSharpRegularIconPackByName,
    ...faSharpSolidIconPackByName,
};
/**
 * Buefy has some internal icon names that map to font awesome icon names.
 * Icons that are not rendering may have their name overridden here. This may
 * also be used to map aliased icon names to their main name, ensuring the
 * correct pack is used, without having to replace usages.
 */
const iconNameOverrides = {
    'alert-circle': 'exclamation-circle',
};

export { faIconPackByName, faIcons, faSharpRegularIconNames, faSharpRegularIconPackByName, faSharpRegularIcons, faSharpSolidIconNames, faSharpSolidIconPackByName, faSharpSolidIcons, iconNameOverrides };
